import useLocalStorage from '@/hooks/useLocalStorage';
import EmptyStarIcon from '../Icons/EmptyStar';

import {WishList} from '../VillageCard/Options';
import {useEffect} from 'react';
import {Village} from '@/services/types';
import FilledStarIcon from '../Icons/FilledStar';
import IVillageSideColumnDictionary from '@/dictionaries/components/villageSideColumn/types';
import useVillageContext from '@/hooks/useVillageContext';
import useCurrency from '@/hooks/useCurrency';
import {getVillageWishListInfos} from '@/utils/village';

type Props = {
  village: Village;
  villageSideColumnDict: IVillageSideColumnDictionary;
};

export default function VillageSideColumnShortlist({
  village,
  villageSideColumnDict,
}: Props) {
  const {addToShortlist, removeFromShortlist} = villageSideColumnDict;
  const {inWishList, handleWishList} = useVillageContext();
  const [wishList, setWishList] = useLocalStorage('villas', [] as WishList[]);

  const {currency} = useCurrency();

  const wishListInfos = getVillageWishListInfos(village, currency.value);

  function handleVillageWishList() {
    let newWishList: WishList[] = [];

    if (!inWishList) {
      newWishList = [...wishList, wishListInfos];
    } else {
      newWishList = wishList.filter(
        (saved) => saved.title !== wishListInfos.title,
      );
    }
    setWishList(newWishList);
  }

  useEffect(() => {
    const isSaved = wishList.some(
      (savedVillage) => savedVillage.title === village.title,
    );
    if (isSaved) {
      handleWishList(true);
    } else {
      handleWishList(false);
    }
    //eslint-disable-next-line
  }, [wishList]);

  return (
    <div className="w-full flex-[0_0_auto] mb-8 flex flex-wrap">
      <div className="mx-auto w-full flex-[0_0_auto]">
        <div
          onClick={handleVillageWishList}
          className="cursor-pointer w-fit mx-auto flex flex-wrap justify-center items-center content-center">
          {inWishList ? (
            <FilledStarIcon className="relative top-[-2px] w-6 h-6 fill-current text-primary" />
          ) : (
            <EmptyStarIcon className="relative top-[-2px] w-6 h-6 fill-current text-primary" />
          )}
          <span className="text-primary ml-2">
            {inWishList ? removeFromShortlist : addToShortlist}
          </span>
        </div>
      </div>
    </div>
  );
}
